var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("会員情報")])])],1),_c('el-row',[_c('el-col',[_c('UserData')],1)],1),_c('el-row',{staticStyle:{"margin-top":"50px"}},[_c('el-col',[_c('EmailList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }